import fetchLocation from "utils/fetch-locations"
import fetchSlugs from "utils/fetch-slugs"
import fetchSocialMedia from "utils/fetch-social-media"
import BlogHero from "../../components/BlogHero"
import BlogList from "../../components/BlogList"
import Layout from "../../components/Layout"
import DynamicContent from "../../components/content/DynamicContent"
import { createApolloClient } from "../../utils/apollo"
import { buildDetailQuery } from "../../utils/blueprints/presse"
import fetchCompany from "../../utils/fetch-company"
import fetchNav from "../../utils/fetch-nav"
import { replaceVariables } from "../../utils/replaceVariables"

function PressePage({
  content = {},
  navs,
  company,
  locations,
  socialMediaLinks,
}) {
  return (
    <Layout
      navs={navs}
      company={company}
      content={content}
      locations={locations}
      socialMediaLinks={socialMediaLinks}
    >
      <BlogHero data={content} />
      <DynamicContent content={content} />
      <BlogList
        headlineType="h2"
        headlineItemType="h3"
        title="Weitere Themen"
        blogPosts={content.linked_presse_entries}
        content={content}
      />
    </Layout>
  )
}

// Data for current page
// export const getServerSideProps = async (context) => {
export const getStaticProps = async (context) => {
  const slug = context.params.slug
  const { previewData } = context

  const apollo = createApolloClient(previewData?.token ?? null)

  const [res, navs, company, locations, socialMediaLinks] = await Promise.all([
    apollo.query({
      query: buildDetailQuery({
        slug,
        isPreview: !!context?.previewData?.token,
        unit: context?.previewData?.unit,
      }),
    }),
    fetchNav(apollo, previewData?.unit),
    fetchCompany(apollo, previewData?.unit),
    fetchLocation(apollo, previewData?.unit),
    fetchSocialMedia(apollo, previewData?.unit),
  ])

  if (res.errors?.length) {
    throw new Error(res.errors[0]?.message)
  }

  const data = (res.data.entries.data || []).filter((e) => !!e)

  const content = data[0]

  if (!content) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      content: await replaceVariables(content),
      navs,
      company,
      locations,
      socialMediaLinks,
    },
    // revalidate: 30,
  }
}

// Generate static paths for SSR
export const getStaticPaths = async () => {
  let paths = await fetchSlugs("presse")
  paths = paths.map((path) => path.url)

  return {
    paths,
    fallback: false,
  }
}

export default PressePage
